// CANONICAL COPY (GH #7115). src/constants/obligations/obl-ski-byod-policy.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-ski-byod-policy',
  title: 'Establish and enforce a BYOD policy with MDM/EMM controls and signed employee agreement',
  description:
    'If personal devices are permitted for service delivery, a BYOD policy must be in place covering: a signed employee agreement specifying responsibilities and organisational rights; enforcement of technical controls via Enterprise Mobility Management (EMM) or Mobile Device Management (MDM); and secure deployment of enterprise applications (e.g. via virtual desktop or sandboxing).',
  category: 'assets',
  scfIds: ['SCF-AST-006', 'SCF-PPL-002'],
  cadence: { frequency: '1y', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [
    { type: 'document-published', description: 'BYOD policy is published and accessible' },
    { type: 'document-approved', description: 'BYOD policy has been approved' },
    { type: 'document-within-sla', description: 'Policy review is not overdue' },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
